const TheContainer = () => import("@/containers/TheContainer.vue")
const ChargebackList = () => import("./ChargebackList.vue")
const ChargebackDetail = () => import("./ChargebackDetail.vue")

export default [
    // Admin (global scope)
    {
        path: '/admin/chargebacks',
        component: TheContainer,
        meta: { perms: ['admin.accounting.chargeback.list'] },
        children: [
            {
                path: '',
                name: 'admin.chargebacks',
                component: ChargebackList,
                meta: {
                    label: 'Disputes',
                    scopeType: 'global',
                    permission: 'admin.accounting.chargeback.list'
                },
            },
            {
                path: ':id',
                name: 'admin.chargebacks.detail',
                component: ChargebackDetail,
                meta: {
                    label: 'Dispute Detail',
                    scopeType: 'global',
                    permission: 'admin.accounting.chargeback.detail'
                },
            },
        ]
    },

    // Contract Manager scope
    {
        path: '/contract-manager/:contractManagerId/chargebacks',
        component: TheContainer,
        meta: {
            perms: ['contract_manager.accounting.chargeback.list'],
            breadcrumb: (context) => {
                const cm = context.store.getters['contractManager/contract_manager']
                const contractManagerId = context.route.params.contractManagerId

                if (!cm || cm.id !== parseInt(contractManagerId)) {
                    context.store.dispatch('contractManager/fetchContractManager', contractManagerId)
                        .catch(() => {})
                }

                return [
                    { to: { name: 'index' }, text: context.gettext('Dashboard') },
                    { to: { name: 'contract_manager.list' }, text: 'Contract Managers' },
                    {
                        to: { name: 'contract_manager.detail', params: { id: contractManagerId } },
                        text: cm && cm.id === parseInt(contractManagerId) ? cm.name : `Contract Manager #${contractManagerId}`
                    }
                ]
            },
            breadcrumbMode: 'replace'
        },
        children: [
            {
                path: '',
                name: 'contractManager.chargebacks',
                component: ChargebackList,
                meta: {
                    label: 'Disputes',
                    scopeType: 'contract-manager',
                    permission: 'contract_manager.accounting.chargeback.list'
                },
            },
            {
                path: ':id',
                name: 'contractManager.chargebacks.detail',
                component: ChargebackDetail,
                meta: {
                    label: 'Dispute Detail',
                    scopeType: 'contract-manager',
                    permission: 'contract_manager.accounting.chargeback.detail'
                },
            },
        ]
    },
]
